import { paletteColors } from "./colors";

/* theme.spacing(2); // = 0.25 * 2rem = 0.5rem = 8px */
const theme = {
  palette: { ...paletteColors },
  spacing: (factor: number) => `${0.25 * factor}rem`, // (estratégia do Bootstrap)
  typography: {
    // Diz ao Material-UI qual é o font-size no elemento html.
    htmlFontSize: 16,
  },
  overrides: {
    MuiTypography: {
      colorTextSecondary: {
        color: paletteColors.gray[400],
      },
    },
    MuiSnackbarContent: {
      action: {
        "& .MuiButton-label": {
          color: paletteColors.white,
        },
      },
    },
    MuiAlert: {
      message: {
        whiteSpace: "break-spaces",
      },
      action: {
        "& .MuiButton-label": {
          color: paletteColors.white,
        },
      },
    },
    MuiButton: {
      root: {
        padding: "0.75rem 1.5rem",
        borderRadius: "4px",
        letterSpacing: "1px",
        transition: "all 200ms ease-in",
        lineHeight: "16px",
        textTransform: "uppercase" as any,
        "&$containedPrimary": {
          color: paletteColors.white,

          "&:hover": {
            backgroundColor: paletteColors.primary.buttonHover,
          },
        },
      },
      text: {
        padding: "0.75rem",
      },
      textPrimary: {
        "&:hover": {
          // valor do primary.buttonHover convertido para rgb
          backgroundColor: "rgba(7, 50, 134, 0.04)",
        },
      },
    },
    MuiInput: {
      underline: {
        "&:before": {
          borderBottom: "1px solid " + paletteColors.gray.dark,
        },
        "&:after": {
          borderBottom: "2px solid " + paletteColors.primary.main,
        },
        "&:hover:not($disabled):not($focused):not($error):before": {
          borderBottom: "2px solid " + paletteColors.gray.dark,
        },
      },
      formControl: {
        marginTop: "0.75rem !important",
      },
      input: {
        fontSize: "1rem",
        fontWeight: "400 !important" as any,
        padding: "0.5rem 0.25rem",
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: "0.8rem",
        color: paletteColors.gray.dark + " !important",
        textTransform: "capitalize" as any,
        letterSpacing: 2,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: "2px",
        backgroundColor: paletteColors.white,
      },
    },
    MuiDialogTitle: {
      root: {
        padding: "1.25rem",
        paddingBottom: "0.5rem",
        color: paletteColors.black,
      },
    },
    MuiDialogContent: {
      root: {
        minWidth: 600,
        "&.MuiPickersModal-dialog": {
          minWidth: "fit-content",
          width: "100%",
        },
      },
    },
    MuiDialogActions: {
      root: {
        paddingTop: "0.75rem",
      },
    },
    MuiTabs: {
      flexContainer: {
        height: "100%",
      },
    },
    MuiStepper: {
      root: { backgroundColor: "transparent", padding: "1rem" },
    },
    MuiStepLabel: {
      alternativeLabel: {
        marginTop: "0.25rem !important",
      },
      label: {
        marginTop: "0.25rem !important",
        fontSize: "0.7rem",
        fontWeight: "400 !important" as any,
      },
    },
  },
};

export default theme;
